module.exports = __webpack_public_path__ + "static/Jan Szczepkowski w milanowskim ogrodzie-9da977aaddc76dc22369d73fe80802a8.jpg";